module.exports = __webpack_public_path__ + "static/media/Group77.708fdc2e.png";